export default {
  ROUTE: 'ROUTE',
  FLIGHT_NUMBER: 'FLIGHT_NUMBER'
}
